import React, { createContext, useContext, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const NavigationContext = createContext();

export const NavigationProvider = ({ children }) => {
  const navigate = useNavigate();

  const storeScrollPosition = () => {
    sessionStorage.setItem('scrollPosition', window.scrollY);
  };

  const restoreScrollPosition = () => {
    const storedScrollPosition = sessionStorage.getItem('scrollPosition');
    if (storedScrollPosition) {
      window.scrollTo(0, parseInt(storedScrollPosition, 10));
    }
  };

  const handleUserPageNav = useCallback(
    (userId) => {
      storeScrollPosition();
      navigate(`/user/${userId}`);
    },
    [navigate]
  );

  const handleUserPageNavByHandle = useCallback(
    (handle) => {
      storeScrollPosition();
      navigate(`/user/@${handle}`);
    },
    [navigate]
  );

  const handleHomeNav = useCallback(() => {
    storeScrollPosition();
    navigate('/');
    restoreScrollPosition();
  }, [navigate]);

  const handleNotificationsNav = useCallback(
    (userId) => {
      storeScrollPosition();
      navigate(`/notifs/${userId}`);
    },
    [navigate]
  );

  const handleSearchNav = useCallback(() => {
    storeScrollPosition();
    navigate('/search');
  }, [navigate]);

  const handleSearchWithQuery = useCallback(
    (query) => {
      storeScrollPosition();
      navigate(`/search?q=${encodeURIComponent(query)}`);
    },
    [navigate]
  );

  const handleSettingsNav = useCallback(() => {
    storeScrollPosition();
    navigate('/settings');
  }, [navigate]);

  const openSongPage = useCallback(
    (songId, commentId, replyId) => {
      storeScrollPosition();
      const params = new URLSearchParams();
      if (commentId != null && commentId !== '') {
        params.set('commentId', String(commentId));
      }
      if (replyId != null && replyId !== '') {
        params.set('replyId', String(replyId));
      }
      const qs = params.toString();
      navigate(qs ? `/song/${songId}?${qs}` : `/song/${songId}`);
    },
    [navigate]
  );

  return (
    <NavigationContext.Provider
      value={{
        handleUserPageNav,
        handleUserPageNavByHandle,
        handleHomeNav,
        handleNotificationsNav,
        handleSearchNav,
        handleSearchWithQuery,
        handleSettingsNav,
        openSongPage,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => useContext(NavigationContext);
